// Used from account/login-register.js when coming from the referral email / shared link
// Page example: https://www.astrthelabel.com/account/register?promo=referral&referrer=605521543268&email=alex@astrthelabel.com
export default class CustomerReferralRegistration {
  referrer_id;

  constructor(referrer_id) {
    this.referrer_id = referrer_id;
  }

  updateForm = () => {
    const registration_form = document.getElementById('create_customer');
    if (!registration_form) {
      return;
    }

    // <input id="promoField" type="hidden" name="customer[note][promo]" value="referral" />
    const input = document.createElement('input');
    input.setAttribute('id', 'promoField');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'customer[note][promo]');
    input.setAttribute('value', 'referral');
    registration_form.appendChild(input);

    // <input id="referrerField" type="hidden" name="customer[note][referrer]" value="referrer_id" />
    const input_referrer = document.createElement('input');
    input_referrer.setAttribute('id', 'referrerField');
    input_referrer.setAttribute('type', 'hidden');
    input_referrer.setAttribute('name', 'customer[note][referrer]');
    input_referrer.setAttribute('value', this.referrer_id);
    registration_form.appendChild(input_referrer);

    // Append a message below the submit button
    const info = document.createElement('div');
    info.classList.add('referral-info');
    info.innerHTML = `<span>You will receive your promo code by email a few minutes after signing up.</span>`;
    registration_form.appendChild(info);
  };

  updateImageContent = () => {
    const account_loyalty = document.querySelector('.account-loyalty');
    if (account_loyalty) {
      account_loyalty.classList.add('referral-program');
    }

    const h3 = document.querySelector('.early-access_top h3');
    if (h3) h3.remove();
    
    const img = document.querySelector('.early-access_image');
    if (img) img.remove();
    
    const bottom = document.querySelector('.account-loyalty__bottom');
    if (bottom) bottom.remove();

    const title = document.createElement('div');
    title.classList.add('referral-title');
    // title.innerHTML = `ASTR THE LABEL<br>REFERRAL PROGRAM`;
    title.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/2483/6632/files/referral-program-logo-horizontal.png?v=1727212003" alt="Refer a friend - Give $20, Get $20" />`;

    const early_access_top = document.querySelector('.early-access_top');
    if (early_access_top) {
      early_access_top.appendChild(title);
    }

    const loyalty_top = document.querySelector('.account-loyalty__top');
    if (loyalty_top) {
      loyalty_top.innerHTML = `
      <p class="referral-intro">Finish signing up to receive your promo code via email.</p>
      <p class="referral-desc">Invite friends to enjoy $20 off their first $50+ purchase, and earn $20 for each successful referral.</p>
    `;
    }

    const loyalty_list = document.querySelector('.account-loyalty__list');
    if (loyalty_list) {
      loyalty_list.innerHTML = `
      <li class="account-loyalty__item ">Invite your friends to shop ASTR the Label.</li>
      <li class="account-loyalty__item ">Your friends get $20 off their first $50+ purchase.</li>
      <li class="account-loyalty__item ">You earn $20 for every friend that makes a qualifying purchase.</li>
    `;
    }
  };
}
